// Query client singleton module that will always return the same instance
import { QueryClient } from 'vue-query'

const queryClient = new QueryClient()
export default queryClient
